// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
    text-align: center;
}

.buttons-container > * {
    margin: 20px;
}

.buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.buttons-container > button {
    align-items: center;
    justify-content: center;
}

.datepicker-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.datepicker-container > p {
    margin: 0;
}

input {
    width: 120px;
}


.table-container > * {
    width: 1000px;
}

/* Media query for smaller screens */
@media (max-width: 800px) {
    .table-container > * {
        width: 95%;
    }
    .datepicker-container {
        width: 100%;
    }
}

.buttons-container > div {
    display: flex;
    gap: 10px;
}

.card-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.table-container {
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
}


.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 20px;
    margin-top: 40px;;
}
`, "",{"version":3,"sources":["webpack://./src/components/MainPage/MainPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;AACjB;;AAEA,oCAAoC;AACpC;IACI;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,gBAAgB;AACpB","sourcesContent":["div {\n    text-align: center;\n}\n\n.buttons-container > * {\n    margin: 20px;\n}\n\n.buttons-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.buttons-container > button {\n    align-items: center;\n    justify-content: center;\n}\n\n.datepicker-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.datepicker-container > p {\n    margin: 0;\n}\n\ninput {\n    width: 120px;\n}\n\n\n.table-container > * {\n    width: 1000px;\n}\n\n/* Media query for smaller screens */\n@media (max-width: 800px) {\n    .table-container > * {\n        width: 95%;\n    }\n    .datepicker-container {\n        width: 100%;\n    }\n}\n\n.buttons-container > div {\n    display: flex;\n    gap: 10px;\n}\n\n.card-container {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.table-container {\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    width: 100%;\n}\n\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    gap: 20px;\n    margin-top: 40px;;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
